<template>
  <div class="user">
    <div class="login">
      <ul class="login-tabbar">
        <li class="login-tabbar__item login-tabbar__item--active">注册账号</li>
      </ul>

      <ul class="login-form-content">
        <li class="login-form-content__phone">
          <el-form
            ref="userForm"
            :model="userForm"
            :rules="userRules"
            key="phone"
          >
            <el-form-item prop="phoneNumber">
              <el-input
                v-model="userForm.phoneNumber"
                placeholder="输入手机号"
                maxlength="11"
                class="input-with-select"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="verifyCode">
              <el-input v-model="userForm.verifyCode" placeholder="输入验证码">
                <el-button
                  type="primary"
                  slot="append"
                  :disabled="disabled"
                  @click="getVerifyCode"
                  >{{ valiBtn }}</el-button
                >
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <div style="font-size: 16px">
                8-16位字符，同时包括数字、大小写字母和特殊字符四种组合;特殊字符需在~!@#$%^&*()-+_=,.范围内选择。
              </div>
              <el-input
                class="input-with-icon"
                placeholder="请输入密码"
                v-model="userForm.password"
                :type="passwordInputType"
              >
                <i
                  slot="suffix"
                  :class="
                    passwordInputType === 'password'
                      ? 'el-icon-turn-off'
                      : 'el-icon-open'
                  "
                  @click="togglePasswordInputType"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="userPassword">
              <el-input
                class="input-with-icon"
                placeholder="确认密码"
                v-model="userForm.userPassword"
                :type="userPasswordInputType"
              >
                <i
                  slot="suffix"
                  :class="
                    userPasswordInputType === 'password'
                      ? 'el-icon-turn-off'
                      : 'el-icon-open'
                  "
                  @click="toggleUserPasswordInputType"
                />
              </el-input>
            </el-form-item>
          </el-form>
        </li>
      </ul>
      <div class="login__button">
        <bytedance-button
          :loading="loading"
          @click="handlerLogin"
          @keydown.enter.native="handlerLogin"
          type="primary"
          size="large"
          tabindex="0"
          ><span v-if="!loading">注 册</span>
          <span v-else>注 册 中...</span></bytedance-button
        >
      </div>
      <div style="float: right; margin-top: 10px">
        <el-button type="text" class="link-type" @click="goBack"
          >使用已有账户登录</el-button
        >
      </div>
    </div>

    <Verify
      @success="success"
      :mode="'pop'"
      :captchaType="captchaType"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>
<script>
import { sendCode, register } from "@/api/index.js";
import Verify from "./../components/verifition/Verify";
import { encryptSm4 } from "@/helper/sm4";
export default {
  name: "register",
  components: {
    Verify,
  },
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.userForm.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };

    return {
      captchaType: "",
      valiBtn: "获取验证码",
      disabled: false,
      userForm: {
        phoneNumber: "",
        verifyCode: "",
        password: "",
        userPassword: "",
      },
      userRules: {
        phoneNumber: [
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入请输入合法的手机号",
            trigger: "blur",
          },
        ],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          {
            min: 8,
            max: 16,
            message: "用户密码长度必须介于 8 和 16 之间",
            trigger: "blur",
          },
          {
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()-+_=,.])[a-zA-Z\d~!@#$%^&*()-+_=,.]{8,16}$/,
            message: "密码必须包含大小写字母，数字，特殊符号",
            trigger: "blur",
          },
        ],
        userPassword: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
      },
      passwordInputType: "password",
      userPasswordInputType: "password",
      loading: false,
    };
  },
  created() {},
  methods: {
    success(params) {
      // params 返回的二次验证参数, 和登录参数一起回传给登录接口，方便后台进行二次验证
      this.tackBtn(); //验证码倒数60秒
      this.$set(params, "phoneNumber", this.userForm.phoneNumber);
      sendCode(params).then((res) => {});
    },

    //获取验证码 并只验证手机号 是否正确
    getVerifyCode() {
      let isValid = true;
      this.$refs["userForm"].validateField(["phoneNumber"], (err) => {
        if (err) {
          isValid = false;
          console.log("未通过");
          return;
        } else {
          console.log("已通过");
        }
      });
      if (isValid) {
        this.captchaType = Math.random() < 0.5 ? "blockPuzzle" : "clickWord";
        this.$refs.verify.show();
      }
    },

    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    },

    handlerLogin() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          if (this.userForm.password == this.userForm.userPassword) {
            this.loading = true;
            register(
              this.userForm.phoneNumber,
              encryptSm4(this.userForm.verifyCode),
              encryptSm4(this.userForm.userPassword)
            )
              .then((res) => {
                if (res.code == 200) {
                  this.$message({
                    showClose: true,
                    message: "注册成功",
                    type: "success",
                  });
                  this.loading = false;
                  this.$router.go(-1);
                } else {
                  this.$message({
                    showClose: true,
                    message: res.msg,
                    type: "warning",
                  });
                  this.loading = false;
                }
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            this.$message({
              showClose: true,
              message: "输入的两次密码不相同",
              type: "warning",
            });
          }
        }
      });
    },

    togglePasswordInputType() {
      this.passwordInputType =
        this.passwordInputType === "password" ? "text" : "password";
    },

    toggleUserPasswordInputType() {
      this.userPasswordInputType =
        this.userPasswordInputType === "password" ? "text" : "password";
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less">
.input-with-select {
  &__divider {
    border-color: @border-extralight-color;
    border-top-width: 0;
    margin-top: 0;
  }
  .el-select .el-input {
    width: 130px;
  }
  .el-input-group__prepend {
    background-color: #fff;
  }
}
.input-with-icon {
  .el-input__suffix {
    cursor: pointer;
    margin-right: 3px;
  }
}

.el-form-item {
  margin-bottom: 30px;
}
</style>
<style scoped lang="less">
.user {
  // height: calc(100vh - 380px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.login {
  width: 500px;
  &-tabbar {
    display: flex;

    &__item {
      padding-bottom: 8px;
      margin-right: 30px;
      cursor: pointer;
      font-weight: @font-weight-primary;
      font-size: @font-size-large;
      color: @secondary-text-color;
      &:hover {
        color: @main-color;
      }
      &--active {
        border-bottom: 2px solid @main-color;
        color: @main-color;
      }
    }
  }

  &-form-content {
    margin: 40px 0;
  }
  .link-type {
    color: #337ab7;
    margin-right: 10px;
    font-size: 16px;
  }
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
